import { render, staticRenderFns } from "./BaseAuthViewTemplate.vue?vue&type=template&id=5f59d0a2&"
import script from "./BaseAuthViewTemplate.vue?vue&type=script&lang=js&"
export * from "./BaseAuthViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports